import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import RechercheGlobale, { EVENEMENT_RECHERCHE } from './RechercheGlobale';
import '../assets/styles/Layout.css';

function Layout() {
  // En dessous de 900px la barre latérale devient un tiroir : elle sort de
  // l'écran et se rappelle par la barre du haut.
  const [menuOuvert, setMenuOuvert] = useState(false);
  // La recherche globale n'occupe l'écran que sur demande : loupe de la
  // sidebar ou Ctrl+K. `rechercheSignal` redonne le focus à une barre déjà
  // ouverte.
  const [rechercheOuverte, setRechercheOuverte] = useState(false);
  const [rechercheSignal, setRechercheSignal] = useState(0);
  const { pathname } = useLocation();

  useEffect(() => {
    const ouvrir = () => {
      setRechercheOuverte(true);
      setRechercheSignal((n) => n + 1);
    };
    const surTouche = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        ouvrir();
      }
    };
    window.addEventListener(EVENEMENT_RECHERCHE, ouvrir);
    window.addEventListener('keydown', surTouche);
    return () => {
      window.removeEventListener(EVENEMENT_RECHERCHE, ouvrir);
      window.removeEventListener('keydown', surTouche);
    };
  }, []);

  // Changer de page referme le tiroir : sur mobile il couvre le contenu.
  useEffect(() => {
    setMenuOuvert(false);
  }, [pathname]);

  useEffect(() => {
    if (!menuOuvert) return;
    const surEchap = (e) => {
      if (e.key === 'Escape') setMenuOuvert(false);
    };
    window.addEventListener('keydown', surEchap);
    return () => window.removeEventListener('keydown', surEchap);
  }, [menuOuvert]);

  return (
    <div className="app-layout">
      <header className="app-topbar">
        <button
          type="button"
          className="app-burger"
          onClick={() => setMenuOuvert(true)}
          aria-label="Ouvrir le menu"
          aria-expanded={menuOuvert}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="app-topbar-brand">
          <span className="app-topbar-mark">S</span>
          <span className="app-topbar-title">Studmin</span>
        </div>
      </header>

      {menuOuvert && (
        <div className="app-backdrop" onClick={() => setMenuOuvert(false)} aria-hidden="true" />
      )}

      <Sidebar ouvert={menuOuvert} onFermer={() => setMenuOuvert(false)} />

      {/* La recherche globale se superpose aux pages du back-office quand on
          l'appelle, sans prendre de hauteur le reste du temps. */}
      <div className="app-principal">
        {rechercheOuverte && (
          <div className="app-recherche">
            <RechercheGlobale
              signalFocus={rechercheSignal}
              onFermer={() => setRechercheOuverte(false)}
            />
          </div>
        )}
        <main className="app-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
